<template>
	<div class="help-more-songs">
		<div class="title">⬆ Chceš víc písniček?</div>
		<p>
			<strong>Můžeš je přidat z externích zdrojů!</strong><br><br>
			Klikni vlevo nahoře na tlačítko "<strong>Všechny písničky</strong>" a poté na "<strong>Přidat písničku</strong>".<br><br>
			Do vyhledávacího políčka pak napiš část textu nebo název písničky.
		</p>
	</div>
</template>

<script>
	export default {
		name: "HelpMoreSongs",
	}
</script>

<style lang="scss">
	.help-more-songs {
		color: white;
		padding: 25px 15px 0 15px;
		line-height: 20px;
		opacity: 0.8;

		.title {
			font-size: 20px;
		}

		p {
			strong {
				font-weight: 600;
			}
		}
	}
</style>
